import React from "react";
import { Link } from "react-router-dom";

const CategorySeeAllButton = ({to}) => {
  return (
    <Link
      to={to}
      className="ml-auto h-full text-xs text-yellow-400 float-right self-center"
    >
      ပိုမိုကြည့်ရှုရန်
    </Link>
  );
};

export default CategorySeeAllButton;
